<script>
  import "../app.scss";

  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  import { configureScope } from "@sentry/browser";

  import GTM from "$lib/components/GTM.svelte";
  import Header from "$lib/components/Header.svelte";
  import Footer from "$lib/components/Footer.svelte";
  import BackToTop from "$lib/components/BackToTop.svelte";

  import { transformDocumentHeadings } from "$lib/utilities/headings";

  export let data;

  let fundraiseUpScript;

  let contentHeight;
  let viewportHeight;
  $: fourFoldsOrMore = contentHeight >= viewportHeight * 4;

  onMount(async () => {
    // Until we fix hydration, there's no reason to check for this.  It must run when the page is loaded.
    //if (import.meta.env.MODE !== 'production') {
    await transformDocumentHeadings(document);
    //}

    //Set mode to correct live mode before adding script to the page.
    window.fundraiseup_livemode = import.meta.env.VITE_FUNDRAISE_UP_LIVE_MODE === "true"; // if true, FundraiseUp is live
    fundraiseUpScript = "https://cdn.fundraiseup.com/widget/AHNVSXNQ";
  });

  configureScope((scope) => scope.setTransactionName(`${$page.url?.pathname}`));

  //In the future, once identity is in place, we can also link users to this
  //data via the following:
  //Sentry.setUser({ email: "jane.doe@example.com" });
  //}
</script>

<svelte:window bind:innerHeight={viewportHeight} />

<svelte:head>
  {#if fundraiseUpScript}
    <script async src={fundraiseUpScript}></script>
  {/if}
</svelte:head>

<div data-headings-start>
  <a
    id="skip-to-content"
    href="#main"
    class="absolute z-50 left-0 right-0 w-161 m-auto text-center top-[-44px] focus-visible:top-0 bg-white px-16 py-4 rounded-8 rounded-t-0 active:text-indigo-700 focus:rounded-8 focus:rounded-t-0 generic-focus focus:border-t-0 transition-all duration-500"
    >Skip to content</a
  >

  <GTM cookieBanner={data.cookieBanner} />

  <Header
    utilityMenu={data.headerUtilityMenu}
    primaryMenu={data.headerProductMenu}
    productRootUrl={data.productRootUrl}
  />

  <main
    id="main"
    class="flex-1 relative z-0 focus:outline-none min-h-screen bg-neutral-50"
    data-headings-increment=""
    bind:clientHeight={contentHeight}
  >
    <slot />
  </main>

  {#if fourFoldsOrMore}
    <BackToTop href="#skip-to-content" {viewportHeight} />
  {/if}

  <Footer
    utilityMenu={data.footerUtilityMenu}
    primaryMenu={data.footerProductMenu}
    productRootUrl={data.productRootUrl}
    trailingContent={data.trailingFooterContent}
  />
</div>
